module.exports = __webpack_public_path__ + "static/media/bigLogo.ae305d2c.png";